import CountDetails from './CountDetails'

export default CountDetails
